import { BRAND } from '../theme/brandTokens';

export const DASHBOARD_PERIODS = Object.freeze({
  THIS_WEEK: 'thisWeek',
  LAST_WEEK: 'lastWeek',
  THIS_MONTH: 'thisMonth',
  LAST_MONTH: 'lastMonth',
  THIS_YEAR: 'thisYear',
  LAST_YEAR: 'lastYear',
});

export const DASHBOARD_PERIOD_OPTIONS = Object.values(DASHBOARD_PERIODS);

export const NEW_CUSTOMER_WINDOW_DAYS = Object.freeze([7, 30]);
export const RETURN_RATE_WINDOW_DAYS = Object.freeze([30, 60]);

export const PEAK_TIME_LEVELS = Object.freeze([
  { maxPercent: 20, color: '#3b82f6' },
  { maxPercent: 40, color: '#22c55e' },
  { maxPercent: 60, color: '#eab308' },
  { maxPercent: 80, color: '#f97316' },
  { maxPercent: 100, color: '#ef4444' },
]);

export const PEAK_TIME_CLOSED_COLOR = BRAND.lineSoft;

export const getPeakTimeColor = (percent) => {
  if (percent === null || percent === undefined) return PEAK_TIME_CLOSED_COLOR;

  const level = PEAK_TIME_LEVELS.find((entry) => percent <= entry.maxPercent)
    ?? PEAK_TIME_LEVELS[PEAK_TIME_LEVELS.length - 1];
  return level.color;
};

export const getPeakTimeLevelIndex = (percent) => {
  if (percent === null || percent === undefined) return -1;

  const index = PEAK_TIME_LEVELS.findIndex((entry) => percent <= entry.maxPercent);
  return index === -1 ? PEAK_TIME_LEVELS.length - 1 : index;
};

export const formatNumber = (value, locale, maximumFractionDigits = 1) => new Intl.NumberFormat(locale, {
  maximumFractionDigits,
}).format(value);

export const formatPercent = (value, locale) => (
  value === null || value === undefined ? '—' : `${formatNumber(value, locale)}%`
);

export const parseDateKey = (dateKey) => {
  const [year, month, day] = dateKey.split('-').map(Number);
  return new Date(year, month - 1, day);
};

export const formatDayMonth = (dateKey) => {
  const date = parseDateKey(dateKey);
  return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}`;
};

export const formatShortMonth = (dateKey, locale) => (
  new Intl.DateTimeFormat(locale, { month: 'short' }).format(parseDateKey(dateKey))
);

export const formatShortWeekday = (weekDay, locale) => {
  const weekDayNumber = typeof weekDay === 'number' ? weekDay : WEEK_DAY_NUMBER_BY_NAME[weekDay];
  const referenceSunday = new Date(2026, 0, 4);
  const date = new Date(referenceSunday);
  date.setDate(referenceSunday.getDate() + (weekDayNumber - 1));
  return new Intl.DateTimeFormat(locale, { weekday: 'short' }).format(date);
};

export const formatHourLabel = (hour) => `${String(hour).padStart(2, '0')}:00`;

const WEEK_DAY_NUMBER_BY_NAME = Object.freeze({
  Sunday: 1,
  Monday: 2,
  Tuesday: 3,
  Wednesday: 4,
  Thursday: 5,
  Friday: 6,
  Saturday: 7,
});

export const WEEK_DAY_DISPLAY_ORDER = Object.freeze([
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]);

export const buildTeamMemberIdsParam = (selectedIds) => (
  Array.isArray(selectedIds) && selectedIds.length > 0 ? selectedIds : undefined
);

export const buildTeamMemberKey = (selectedIds) => (
  Array.isArray(selectedIds) && selectedIds.length > 0 ? [...selectedIds].sort().join(',') : 'all'
);
